export default {
    title: "Fusionar clientes",
    description: "¿Qué campo quieres usar para fusionar los clientes?",
    fieldExternalId: "Id de Integración",
    fieldEmail: "Email",
    fieldWhatsapp: "Teléfono",
    previewButton: "Vista previa",
    previewTitle: "Vista previa",
    clientsColumn: "Clientes",
    nameLabel: "Nombre",
    emailLabel: "E-mail",
    whatsappLabel: "Whats",
    mergeButton: "Fusionar",
    selectFieldAlert: "Selecciona un campo para fusionar los clientes",
    mergeSuccessAlert: "Clientes fusionados con éxito",
};
